export default "\r\n\r\n<router-outlet></router-outlet>\r\n"